import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import ItemList from '@/views/ItemList.vue';
import EditList from '@/views/EditList.vue';
import ItemModify from "@/views/ItemModify.vue";
import DomainList from "@/views/DomainList.vue";
import DisplayModify from "@/views/DisplayModify.vue";
import EditModify from "@/views/EditModify.vue";
import StationList from "@/views/StationList.vue";
import StationAdd from "@/views/StationAdd.vue";
import Audit from "@/views/Audit.vue";
import Login from "@/views/Login.vue";
import AdCreate from "@/views/AdCreate.vue";
import AccountList from "@/views/AccountList.vue";
import ReportOverview from "@/views/ReportOverview.vue";
import ReportOrder from "@/views/ReportOrder.vue";
import ReportOnline from "@/views/ReportOnline.vue";
import DomainEdit from "@/views/DomainEdit.vue";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/edit/list',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/item/list',
    name: 'ItemList',
    component: ItemList,
  },
  {
    path: '/item/modify',
    name: 'ItemModify',
    component: ItemModify,
  },
  {
    path: '/display/modify',
    name: 'DisplayModify',
    component: DisplayModify,
  },
  {
    path: '/audit',
    name: 'Audit',
    component: Audit,
  },
  {
    path: '/audit/:auditType',
    name: 'Audit',
    component: Audit,
  },
  {
    path: '/edit/list',
    name: 'EditList',
    component: EditList,
  },
  {
    path: '/edit/add',
    name: 'EditAdd',
    component: EditModify,
  },
  {
    path: '/edit/modify/:id',
    name: 'EditModify',
    component: EditModify,
  },
  {
    path: '/edit/copy/:id/:country',
    name: 'EditCopy',
    component: EditModify,
  },
  {
    path: '/station/list',
    name: 'StationList',
    component: StationList,
  },
  {
    path: '/station/add',
    name: 'StationAdd',
    component: StationAdd,
  },
  {
    path: '/ad/create',
    name: 'AdCreate',
    component: AdCreate,
  },
  {
    path: '/ad/create/:itemId',
    name: 'AdCreate',
    component: AdCreate,
  },
  {
    path: '/account/list',
    name: 'AccountList',
    component: AccountList,
  },
  {
    path: '/domain/list',
    name: 'DomainList',
    component: DomainList,
  },
  {
    path: '/domain/DomainEdit',
    name: 'DomainEdit',
    component: DomainEdit,
  },
  {
    path: '/report/overview',
    name: 'ReportOverview',
    component: ReportOverview,
  },
  {
    path: '/report/order',
    name: 'ReportOrder',
    component: ReportOrder,
  },
  {
    path: '/report/online',
    name: 'ReportOnline',
    component: ReportOnline,
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
